module.exports = __webpack_public_path__ + "img/Biphasic-clock@2x.d60d9c44.png";